/* Northman KDSS step (snippets/hk-kdss-step.liquid + hk-kdss-kit-rows.liquid). Opt-in products only (custom.kdss_option).
 * - Choice -> line item properties on the kit line: KDSS (+ KDSS guide URL for options 2, 3 and 4).
 * - "KDSS + SuperPro TRC4308 link": Add to cart posts ONE cart/add.js call with items[] = [kit, TRC4308 add-on]; both lines
 *   share a hidden _kdss_group id, the add-on line shows "For: <kit title>". Price summary + buy-box price show kit + add-on.
 * - Cart: an add-on whose kit line is gone is removed; its quantity follows the kit line (reconcile()).
 * - Kit card rows [data-hk-kdss-row] follow the choice.
 */
(function () {
  if (window.__hkKdss) return; window.__hkKdss = true;
  function money(c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cents(s) { var n = String(s || '').replace(/[^0-9.]/g, ''); return n ? Math.round(parseFloat(n) * 100) : 0; }
  function steps() { return Array.from(document.querySelectorAll('[data-hk-kdss]')); }
  function sel(step) { return step.querySelector('select[data-hk-option-position="kdss"]'); }
  function choice(step) { var s = sel(step); return s && s.value ? s.value : ''; }
  function form(step) { return document.forms[step.getAttribute('data-form-id')]; }
  function uid() { return 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  function apply(step) {
    var c = choice(step), f = form(step), addon = +(step.getAttribute('data-addon-price') || 0);
    var props = {};
    step.querySelectorAll('[data-hk-kdss-prop]').forEach(function (i) { props[i.getAttribute('data-hk-kdss-prop')] = i; });
    var label = c ? sel(step).options[sel(step).selectedIndex].getAttribute('data-hk-name') : '';
    // Closed select shows the chosen name only (the +$220 pill sits beside the label), so it never truncates on mobile.
    Array.from(sel(step).options).forEach(function (o) {
      var n = o.getAttribute('data-hk-name'); if (!n) return;
      var sur = +(o.getAttribute('data-surcharge') || 0);
      o.textContent = n + (sur && !o.selected ? ' (+' + money(sur) + ')' : '');
    });
    props.choice.value = label; props.choice.disabled = !c; // every choice recorded on the order, incl. No KDSS
    var g = ['self', 'offset', 'link'].indexOf(c) !== -1; // Reade: guide on options 2, 3 and 4
    props.guide.value = g ? step.getAttribute('data-guide-url') : ''; props.guide.disabled = !g;
    props.group.disabled = true; // set by the add-on click handler (items[]) only
    // kit card
    document.querySelectorAll('[data-hk-kdss-row]').forEach(function (row) {
      var on = row.getAttribute('data-hk-kdss-row').split(',').indexOf(c) !== -1; row.hidden = !on;
      row.querySelectorAll('[data-hk-kdss-note]').forEach(function (n) { n.hidden = n.getAttribute('data-hk-kdss-note') !== c; });
    });
    // standard front springs: dimmed + note while the KDSS offset springs replace them
    document.querySelectorAll('[data-hk-kdss-replaced]').forEach(function (li) {
      li.classList.toggle('is-replaced', c === 'offset');
      var n = li.querySelector('[data-hk-kdss-replaced-note]'); if (n) n.hidden = c !== 'offset';
    });
    // price: summary + buy-box price show kit + add-on
    var scope = step.closest('.shopify-section') || document;
    var sp = scope.querySelector('[data-hk-summary-price]');
    if (sp) {
      if (!sp.hasAttribute('data-hk-kit-price') || sp.getAttribute('data-hk-src') !== sp.textContent) sp.setAttribute('data-hk-kit-price', cents(sp.textContent));
      var kit = +sp.getAttribute('data-hk-kit-price');
      if (kit) { sp.textContent = money(kit + (c === 'link' ? addon : 0)); sp.setAttribute('data-hk-src', sp.textContent); }
    }
    var pl = scope.querySelector('.product-form__info-content .price-list, .product-meta .price-list, .price-list');
    var note = scope.querySelector('[data-hk-kdss-price]');
    if (pl) {
      var sale = pl.querySelector('.price--highlight, .price');
      if (sale) {
        if (!sale.hasAttribute('data-hk-kit-price') || sale.getAttribute('data-hk-src') !== sale.innerHTML) sale.setAttribute('data-hk-kit-price', cents(sale.textContent));
        var k2 = +sale.getAttribute('data-hk-kit-price');
        var vh = sale.querySelector('.visually-hidden'), vht = vh ? vh.outerHTML : '';
        sale.innerHTML = vht + money(k2 + (c === 'link' ? addon : 0)); sale.setAttribute('data-hk-src', sale.innerHTML);
        if (!note) { note = document.createElement('p'); note.className = 'hk-kdss__price'; note.setAttribute('data-hk-kdss-price', ''); pl.after(note); }
        note.hidden = c !== 'link';
        note.innerHTML = 'Kit ' + money(k2) + ' + SuperPro TRC4308 KDSS link ' + money(addon);
      }
    }
  }

  function applyAll() { steps().forEach(apply); }
  // Capture phase: runs before the picker's own handler, so we know whether this KDSS change COMPLETES the kit.
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest && e.target.closest('[data-hk-kdss]');
    if (!s || !e.target.matches('select')) return;
    var f0 = form(s), wasIncomplete = !!(f0 && f0.classList.contains('hk-incomplete'));
    // The picker only hands the combination to Warehouse when a VARIANT option changes; if KDSS completes the kit,
    // hand it over here so the form's variant id is current.
    setTimeout(function () {
      var f = form(s), h = f && document.querySelector('input[data-hk-hidden][data-option-position][form="' + s.getAttribute('data-form-id') + '"]');
      if (wasIncomplete && h && !f.classList.contains('hk-incomplete')) h.dispatchEvent(new Event('change', { bubbles: true }));
      apply(s);
    }, 0);
  }, true);
  document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('select[data-hk-option-name]')) setTimeout(applyAll, 0); });
  document.addEventListener('product:rerender', function () { setTimeout(applyAll, 30); }, true);

  // Add to cart with the TRC4308 add-on: one call, two lines. Runs after hk-option-picker's guard (registered earlier).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-form__add-button[type="submit"]');
    if (!btn || e.defaultPrevented) return;
    var f = btn.form || btn.closest('form'); if (!f) return;
    var step = steps().find(function (s) { return form(s) === f; });
    if (!step || choice(step) !== 'link' || f.classList.contains('hk-incomplete')) return;
    var addonId = step.getAttribute('data-addon-id'); if (!addonId) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var g = uid(), qty = parseInt((f.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + f.getAttribute('id') + '"]') || { value: 1 }).value, 10) || 1;
    var kitProps = {}; // carry every other enabled line property on the form (e.g. Component brand preference)
    new FormData(f).forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') kitProps[m[1]] = v; });
    kitProps['KDSS'] = 'KDSS + SuperPro TRC4308 link'; kitProps['KDSS guide'] = step.getAttribute('data-guide-url'); kitProps['_kdss_group'] = g;
    btn.setAttribute('disabled', 'disabled'); document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [
        { id: +addonId, quantity: qty, properties: { 'For': step.getAttribute('data-kit-title'), '_kdss_group': g, '_kdss_addon': '1' } },
        { id: +f.querySelector('input[name="id"]').value, quantity: qty, properties: kitProps }
      ] })
    }).then(function (r) {
      btn.removeAttribute('disabled');
      btn.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: btn, variant: null, quantity: qty, productAdded: r.ok } }));
      if (r.ok && (window.theme.cartType === 'page')) window.location.href = window.routes.cartUrl;
      if (!r.ok) document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }, true);

  // Cart: remove orphaned add-ons, keep add-on qty = kit qty.
  var busy = false, again = false;
  function reconcile() {
    if (busy) { again = true; return; } busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var kits = {}, ops = [];
      cart.items.forEach(function (it) { var g = it.properties && it.properties._kdss_group; if (g && !it.properties._kdss_addon) kits[g] = (kits[g] || 0) + it.quantity; });
      cart.items.forEach(function (it) {
        var p = it.properties || {}; if (!p._kdss_addon) return;
        var want = kits[p._kdss_group] || 0; if (want !== it.quantity) ops.push({ id: it.key, quantity: want });
      });
      return ops.reduce(function (pr, op) { return pr.then(function () { return _f((window.routes.cartChangeUrl || '/cart/change') + '.js', { hkKdss: true, method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(op) }); }); }, Promise.resolve())
        .then(function () { if (ops.length) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
    }).finally(function () { busy = false; if (again) { again = false; setTimeout(reconcile, 60); } });
  }
  // Theme cart edits (mini cart + cart page) go through /cart/change; re-check the add-on after each one.
  var _f = window.fetch.bind(window);
  window.fetch = function (u, o) {
    var p = _f(u, o), url = typeof u === 'string' ? u : (u && u.url) || '';
    if (/\/cart\/(change|update)/.test(url) && !(o && o.hkKdss)) p.then(function () { setTimeout(reconcile, 60); });
    return p;
  };
  window.hkKdssReconcile = reconcile; window.hkKdssApplyAll = applyAll;
  document.addEventListener('cart:updated', reconcile); document.addEventListener('cart:refresh', function (e) { if (!e.detail || !e.detail.hkKdss) setTimeout(reconcile, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { applyAll(); reconcile(); }); else { applyAll(); reconcile(); }
})();
